export const special = {
  primary: '#000',
  secondary: '#000',
  accent: '#000',
  error: '#000',
  warning: '#ff9800',
  info: '#d7e0dc',
  success: '#4caf50',
  base: '#000',
  surface: '#fff',
}
